import { useState, useEffect } from 'react'
import { gql } from '@apollo/client'
import { Table, Alert, Button } from 'reactstrap'
import Spinner from '../../Spinner/Spinner.js'
import '../Custom.css'
import { getData, getInputParams } from '../CustomUtils'
import { LOSS_SETTLEMENT_FUNDING_REPORT_QUERY } from '../../../graphql.js'
import ColumnHeadings from '../ColumnHeadings.js'
import ParameterValues from '../ParameterValues.js'
import { getTenant } from '../../../utils.js'
import LargeRowHandler from '../LargeRowHandler.js'
import ReportHeading from '../ReportHeading.js'
import { Link } from 'react-router-dom'
import PDFLink from '../../PDFLink/PDFLink.js'

const LOSS_SETTLEMENT_FUNDING_REPORT = gql(LOSS_SETTLEMENT_FUNDING_REPORT_QUERY)

export default function LossSettlementFundingRequestReport({ location }) {
  console.log('LossSettlementFundingRequestReport rendered:', location)
  const inputs = getInputParams(location)
  const [results, setResults] = useState()
  const [graphQLErrors, setGraphQLErrors] = useState([])

  useEffect(() => {
    getData(location, LOSS_SETTLEMENT_FUNDING_REPORT, 'lossSettlementReportFundingRequest', setResults, setGraphQLErrors)
  }, [location])

  if (graphQLErrors.length > 0) {
    return <Alert color="danger">{graphQLErrors[0].message}</Alert>
  } else if (!results) {
    return <Spinner />
  } else {
    const formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' })
    console.log(results)
    const resultRows = []
    let settlementAmountTotal = 0
    let nextAmountToBePaidTotal = 0
    for (let i = 0; i < results.reportData.length; i++) {
      const row = []
      row.push(<td key='-1'>{i+1}</td>)
      for(let j = 0; j < results.reportData[i].length - 1; j++) {
        if (j === 10) {
          settlementAmountTotal += parseFloat(results.reportData[i][j])*100
          row.push(<td key={j} align='right'>{formatter.format(results.reportData[i][j])}</td>)
        }
        else if (j === 11) {
          nextAmountToBePaidTotal += parseFloat(results.reportData[i][j])*100
          row.push(<td key={j} align='right'>{formatter.format(results.reportData[i][j])}</td>)
        } else {
          row.push(<td key={j}>{results.reportData[i][j]}</td>)
        }
      }
      row.push(<td key={-2} style={{verticalAlign: 'middle', width: 'auto'}}><Link to={`/object/${results.reportData[i][results.reportData[i].length-1]}?source=${location.pathname}${location.search}`}><Button color="primary" size="sm">View</Button></Link></td>)
      resultRows.push(<tr key={i}>{row}</tr>)
    } 
 
    settlementAmountTotal /= 100
    nextAmountToBePaidTotal /= 100
    return (
      <div className="custom-scroll">
        <div style={{ textAlign: 'center', margin: '10px 0px' }}>
          <PDFLink url={`LossSettlementFundingRequestPDF?inputs=${JSON.stringify(inputs)}`} />
          <div style={{marginRight: '10px', display: 'inline-block'}} />
          <LargeRowHandler csvUrl={`${process.env.REACT_APP_SERVER}/csv/${getTenant()}/custom/Asbestos/lossSettlementFundingRequestReport/loss_settlement.csv?inputs=${JSON.stringify(inputs)}`} resultsLength={results.reportData.length} />
        </div>
        <Table bordered style={{backgroundColor: 'white'}} >
          <ReportHeading title={'Loss Settlement List Report'} parameterValues={ParameterValues(results)} />
          <tbody>
            <ColumnHeadings results={results} />
            {resultRows}
            <tr key={'totals'}>
              <td colSpan={11} style={{ textAlign: 'right', fontWeight: 'bold' }}>Total</td>
              <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{formatter.format(settlementAmountTotal)}</td>
              <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{formatter.format(nextAmountToBePaidTotal)}</td>
            </tr>
          </tbody>
        </Table>
      </div>
    )
  }
}